/**
 * Created by tofael on 7/13/17.
 */
import React from 'react';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import {green800, red700, white} from 'material-ui/styles/colors';

const style = {
  approveBtn: {
    marginBottom: 12,
    marginTop: 12
  },
  box: {
    backgroundColor: '#fff',
    borderRadius: '1%',
    overflow: 'hidden',
    position: 'relative',
    marginBottom: '24px',
    boxShadow: '0 5px 5px 0 rgba(0,0,0,.25)',
    padding: '10px'
  },
  selectedItem :{
    color:red700
  }
};

const Actions = ({fields, submitStatusUpdate, statusOptions, handleCommentChange, onStatusChange, showAlert, toggleSipDialog, comment, status, locked}) => (
    <form onSubmit={submitStatusUpdate}>
      <div style={style.box}>
        {
          statusOptions &&
          <SelectField
            floatingLabelText="Current status"
            onChange={onStatusChange}
            value={status}
            fullWidth={true}
            selectedMenuItemStyle={style.selectedItem}>
          {
            statusOptions &&
            statusOptions.map((status, index) => (<MenuItem key={index} value={status.value} primaryText={status.label}/>))
          }
        </SelectField>
        }

        {
          handleCommentChange &&
          <TextField
            multiLine={true}
            rows={4}
            rowsMax={4}
            required={fields.doctor_status === 'rejected'}
            value={comment}
            onChange={handleCommentChange}
            floatingLabelText="Comment"
            fullWidth={true}/>
        }
        <br />
        <RaisedButton type="submit" fullWidth={true} primary={true} label="Update"/>
        <br />
        <br />
        {!locked && <RaisedButton onTouchTap={showAlert.bind(null,'Are you sure you want to lock the user ?','lock')} labelColor={white} fullWidth={true} backgroundColor='#696969' label="Lock User"/> }
        {locked && <RaisedButton onTouchTap={showAlert.bind(null,'Are you sure you want to unlock the user ?','unlock')} labelColor={white} fullWidth={true} backgroundColor='#696969' label="Unlock User"/> }
        <br />
        <br />
        <RaisedButton onTouchTap={showAlert.bind(null,'Are you sure you want to reset password for the user ?','reset-password')} labelColor={white} fullWidth={true} backgroundColor={red700} label="Reset Password"/>
        <br />
        <br />
        <RaisedButton onTouchTap={toggleSipDialog} labelColor={white} fullWidth={true} backgroundColor={green800} label="Set SIP Credentials"/>
      </div>
    </form>
);

export default Actions;



// WEBPACK FOOTER //
// ./src/screens/profile/doctor/doctor-actions-component.js